/* global axios */
import ApiClient from './ApiClient';

export const buildCompanyParams = (params = {}) => {
  const queryParams = new URLSearchParams();

  const {
    page = 1,
    sort = 'name',
    company_type,
    status,
    industry,
    owner_id,
  } = params;

  queryParams.append('page', page);
  if (sort) queryParams.append('sort', sort);
  if (company_type) queryParams.append('company_type', company_type);
  if (status) queryParams.append('status', status);
  if (industry) queryParams.append('industry', industry);
  if (owner_id) queryParams.append('owner_id', owner_id);

  return queryParams.toString();
};

export const buildSearchParams = (query, page, sort) => {
  let params = `q=${encodeURIComponent(query)}&page=${page}`;
  if (sort) {
    params = `${params}&sort=${sort}`;
  }
  return params;
};

class CompanyAPI extends ApiClient {
  constructor() {
    super('companies', { accountScoped: true });
  }

  get(params = {}) {
    const requestURL = `${this.url}?${buildCompanyParams(params)}`;
    return axios.get(requestURL);
  }

  getCompany(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(companyData) {
    return axios.post(this.url, { company: companyData });
  }

  update(id, companyData) {
    return axios.patch(`${this.url}/${id}`, { company: companyData });
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  search(query = '', page = 1, sort = 'name') {
    const requestURL = `${this.url}/search?${buildSearchParams(query, page, sort)}`;
    return axios.get(requestURL);
  }

  matchByEmail(email) {
    return axios.get(`${this.url}/match_by_email`, { params: { email } });
  }

  // Nested resources
  getContacts(companyId, page = 1) {
    return axios.get(`${this.url}/${companyId}/contacts`, { params: { page } });
  }

  getDeals(companyId, page = 1) {
    return axios.get(`${this.url}/${companyId}/deals`, { params: { page } });
  }

  getActivities(companyId, page = 1) {
    return axios.get(`${this.url}/${companyId}/activities`, {
      params: { page },
    });
  }
}

export default new CompanyAPI();
